module.exports = __webpack_public_path__ + "img/same-ask-light.ef5693df.svg";